<ion-content class="ion-padding">
  <div class="modal-card beach-card">
    <div class="section-header">
      <ion-icon name="shield-checkmark-outline" class="section-icon"></ion-icon>
      <h2 class="section-title">{{'consenso_privacy_titolo' | tr}}</h2>
    </div>

    <p class="modal-description" [innerHTML]="translation.t('consenso_privacy_descrizione')"></p>

    <form [formGroup]="consentForm" class="consent-form">
      <div class="privacy-checkbox">
        <ion-checkbox aria-label="privacy1-input" formControlName="checkboxPrivacy1">
        </ion-checkbox>
        <p class="privacy-text" [class.error-text]="!consentForm.value.checkboxPrivacy1"
          [innerHTML]="translation.t('signup_presoVisioneTrattamento')">
        </p>
      </div>

      <div class="privacy-checkbox">
        <ion-checkbox aria-label="privacy2-input" formControlName="checkboxPrivacy2">
        </ion-checkbox>
        <p class="privacy-text" [class.error-text]="!consentForm.value.checkboxPrivacy2"
          [innerHTML]="translation.t('signup_presoVisioneInformativa')">
        </p>
      </div>
    </form>

    <privacy-data paginaProvenienza="consenso-privacy"
      [openInModal]="true"
      [customTextOne]="translation.t('trattametoDati')"
      [customTextTwo]="translation.t('finalitaTrattamento')">
    </privacy-data>

    <div class="modal-buttons">
      <ion-button class="modal-button primary-button" expand="block"
        [disabled]="consentForm.invalid"
        (click)="accept()">
        {{'continuaLabel' | tr | uppercase}}
      </ion-button>

      <ion-button class="modal-button close-button" expand="block" (click)="cancel()">
        {{'annullaLabel' | tr | uppercase}}
      </ion-button>
    </div>
  </div>
</ion-content>
